<template>
  <div>
    <el-dialog title="上传图片" :visible.sync="uploadVisible">
      <el-form>
        <el-form-item>
          <el-upload
            action="http://eapi.ruizhiqi.cn/api/upload/uploadformdata"
            list-type="picture-card"
            :on-preview="handlePictureCardPreview"
            v-model="picture"
            size="small"
            ref="uploader"
            :on-success="uploadSuccess"
            :on-remove="onRemove"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog size="100%" :visible.sync="dialogImgPriviewVisible">
      <img width="100%" :src="dialogImageUrl" alt />
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    dialogUploadVisible: {
      type: Boolean
    }
  },
  data() {
    return {
      picture: "",
      dialogImgPriviewVisible: false,
      uploadVisible: this.dialogUploadVisible,
      dialogImageUrl: ""
    };
  },
  methods: {
    uploadSuccess: function(res) {
      this.picture = res.Data.Message;
      this.$emit("UploaderHandler", this.picture);
      this.uploadVisible = false;
      this.$emit("update:dialogUploadVisible", false);
      this.$refs.uploader.clearFiles();
    },
    onRemove: function(file, filelist) {
      this.picture = "";
      this.$emit("UploaderHandler", this.picture);
    },
    handlePictureCardPreview: function(file) {
      this.dialogImageUrl = file.url;
      this.dialogImgPriviewVisible = true;
    }
  },
  watch: {
    dialogUploadVisible: {
      handler(n, o) {
        //n为新值,o为旧值;
        this.uploadVisible = n;
      },
      deep: true
    }
  }
};
</script>